import { createContext, useContext, FC } from 'react';
import { BoxProps, Grid, GridProps } from '@chakra-ui/react';
import clsx from 'clsx';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import 'components/layout/List/style.scss';

type Elements = {
  Body: FC<BoxProps>;
  Header: FC<BoxProps>;
  Item: FC<BoxProps & { selected?: boolean }>;
};

type Context = GridProps;
const ListContext = createContext<Context | null>(null);
const useListContext = () => {
  const ctx = useContext(ListContext);
  if (ctx === null) {
    throw new Error('ListContext is not defined');
  }

  return ctx;
};

type Props = GridProps;
export const List: FC<Props> & Elements = ({ children, ...props }) => {
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ListContext.Provider value={{ ...props }}>
      <FlexColumn>{children}</FlexColumn>
    </ListContext.Provider>
  );
};

List.Header = function ListHeader(props) {
  const gridProps = useListContext();

  return (
    <Grid
      color="brand.grey"
      fontWeight="600"
      textTransform="uppercase"
      borderColor="#eee"
      borderWidth="0 0 2px 0"
      {...gridProps}
      {...props}
    />
  );
};

List.Body = function ListBody(props) {
  return <FlexColumn {...props} />;
};
List.Item = function ListItem({ selected, ...props }) {
  const gridProps = useListContext();

  return (
    <Grid
      className={clsx('merc-list-item', { clickable: props.onClick, selected })}
      alignContent="center"
      alignItems="center"
      borderColor="#eee"
      py={3}
      px={2}
      borderWidth="0 0 2px 0"
      {...gridProps}
      {...props}
    />
  );
};
